import React, { useState, useEffect, Fragment } from 'react';

//components material mui
import { Card, CardHeader, CardContent, Divider, Typography } from '@mui/material';

//hooks
import { useGlobalState } from '../../Utilidades/useGlobalState';

//components

import Contactos from './Registro/Contactos'
import DatosPersonales from './Registro/DatosPersonales'
import { InformacionAdicional } from './Registro/InformacionAdicional/InformacionAdicional';

//config home
import { MOBILE } from './config'

//actions
import { seccionesHabilitadas } from '../../Actions/SeccionPortal/DatosSeccionPortal';

//styles
import { StyleHome, StyleHomeHeader } from '../Tool/Style'

const Registro = ({ deviceIs = "DESKTOP", campos = [], SetCamposDinamicosCRUD, DatosPresonalesInfo, DatosContactoInfo, SetUltimaAdmisionPendiente, SetAdmisionPreExistente, DatosNacionalidadInfo }) => {
    const { etiquetas, dispatch} = useGlobalState();

  
    const [sectionsEnable, setSectionsEnable] = useState([]);
   
    useEffect(() => {
        if (DatosPresonalesInfo.Credenciales.Info.companyId !== "00000000-0000-0000-0000-000000000000")
            getListSectionEnable();
    }, [DatosPresonalesInfo.Credenciales.Info.companyId]);

    const getListSectionEnable = async () => {        
        const objectRequest = {
            portal: 'N',
            companyId: DatosPresonalesInfo.Credenciales.Info.companyId
        };

        const response = await seccionesHabilitadas(objectRequest);

        if (response.status === 200) //si la respuesta fue existosa
        {
            const newArray = response.data.filter(item => item.code === "EmailContactCIF" || item.code === "PhoneContactCIF"
                || item.code === "AddressCIF" || item.code === "NationalityCIF" || item.code === "InfoAdicionalCIF");

            if(newArray.some(x => x.code === "InfoAdicionalCIF"))
                SetCamposDinamicosCRUD(true);
            else
                SetCamposDinamicosCRUD(false);

            setSectionsEnable(newArray);
        }
        else {
            if (response.data.errors) {
                const arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
                MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
            } else {
                MostrarMensaje(dispatch, 'error', [response.statusText]);
            }
            setFieldsEnable([]);
        }
    };

  

    return (
        <div style={deviceIs === MOBILE ? { padding:"14px" } : {} }>
            <Card style={ deviceIs === MOBILE ? { padding:"14px" } : StyleHome.Card}>                
                <DatosPersonales 
                  deviceIs={deviceIs}
                  DatosPresonalesInfo={DatosPresonalesInfo}
                  SetUltimaAdmisionPendiente={SetUltimaAdmisionPendiente} 
                  SetAdmisionPreExistente={SetAdmisionPreExistente} 
               />
            </Card>
            
            {DatosPresonalesInfo.Credenciales.Info.customerId !== '00000000-0000-0000-0000-000000000000' && sectionsEnable.length > 0 && DatosPresonalesInfo.CodigoVerificado.Info === true ?
                <Fragment>
                    <Card style={deviceIs === MOBILE  ? { marginTop:"12px", padding:"14px" } : StyleHome.Card}>
                        <CardHeader
                            style={{ paddingBottom: 0 }}
                            title={
                                <Typography style={{ ...StyleHomeHeader.HeaderText, ...{ fontSize: 24, textAlign: 'center', marginLeft: 0 } }}>
                                    {etiquetas.Home.Et_lblContactos}
                                </Typography>} /> 

                       { deviceIs === MOBILE  ? <Divider sx={{marginTop:"8px", marginBottom:"8px"}}/> : null}  

                        <CardContent sx={deviceIs === MOBILE  ? { padding:'0px'  } : {}}>
                            <Contactos 
                             SectionsEnable={sectionsEnable} 
                             deviceIs={deviceIs}
                             DatosContactoInfo={
                                {
                                    ...DatosContactoInfo,
                                    ...{
                                        DatosNacionalidadInfo: DatosNacionalidadInfo,
                                        Credenciales: DatosPresonalesInfo.Credenciales.Info,
                                        CodigoVerificado: DatosPresonalesInfo.CodigoVerificado.Info === true && DatosPresonalesInfo.ActivadorBotones.Info === true,
                                        ListCamposRequeridos: DatosPresonalesInfo.ListCampReq.Info,
                                    }
                                }}
                            />
                        </CardContent>
                    </Card>
                    {(campos.length > 0 && sectionsEnable.some(x => x.code === "InfoAdicionalCIF")) ?
                        <Card style={deviceIs === MOBILE ? { padding:"14px" } : StyleHome.Card}>
                            <CardHeader
                                style={{ paddingBottom: 0 }}
                                title={
                                    <Typography style={{ ...StyleHomeHeader.HeaderText, ...{ fontSize: 24, textAlign: 'center', marginLeft: 0 } }}>
                                        {etiquetas.Home.Et_InformacionAdicional}
                                    </Typography>} />
                            <CardContent sx={deviceIs === MOBILE  ? { padding:'0px'  } : {}} style={{ paddingTop: '0px' }} >
                                <InformacionAdicional
                                    deviceIs={deviceIs}
                                    campos={campos}
                                    credenciales={DatosPresonalesInfo.Credenciales.Info}
                                />
                            </CardContent>
                        </Card>
                        : null
                    }
                </Fragment> : null}
         
        </div>
    );
};

export default Registro;